export const SET_THEME = 'SET_THEME';
export const SET_DATA_UPLOAD_DIALOG_VISIBILITY = 'SET_DATA_UPLOAD_DIALOG_VISIBILITY';
export const SET_NAV_DRAWER_VISIBILITY = 'SET_NAV_DRAWER_VISIBILITY';
export const SET_TABLE_SELECTED = 'apptable/SET_TABLE_SELECTED';
export const SET_NAV_HEADER = 'apptable/SET_NAV_HEADER';
export const SET_FILTER_VISIBILITY = 'filtertable/SET_FILTER_VISIBILITY';
